<template>
  <div class="p-3">
    <b-row>
      <b-col class="mb-3">
        <h1>Trusted IP Addresses</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mb-3">
        <b-button size="sm" variant="primary" @click="showModal">
          <b-icon-plus />
          Add
        </b-button>
        <i id="pop-info" class="fas fa-info-circle clickable icon-info"></i>
        <b-popover
          target="pop-info"
          placement="right"
          triggers="hover focus"
          content="Users will not be prompted for 2FA code if they login from these IP Addresses."
        ></b-popover>
      </b-col>
    </b-row>
    <div ref="table-container">
      <div v-if="isBusy" class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
      <b-table
        bordered
        small
        striped
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="isBusy"
        class="ip-table"
      >
        <template v-slot:table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(createdAt)="data">
          {{ data.value | datetimelong }}
        </template>
        <template v-slot:cell(editedAt)="data">
          {{ data.value | datetimelong }}
        </template>
        <template v-slot:cell(trustedIPId)="data">
          <span
            class="clickable text-primary mx-1"
            @click="showModalForEdit(data.item)"
          >
            <b-icon-pencil />
          </span>
          <span
            class="clickable text-primary mx-1"
            @click="deleteItem(data.item)"
          >
            <b-icon-trash />
          </span>
        </template>
      </b-table>
    </div>

    <b-modal
      centered
      ref="form-modal"
      :title="isEdit ? 'Edit IP Address' : 'Add IP Address'"
    >
      <b-form ref="main-form">
        <div class="form-group row">
          <div class="col-sm-3">
            <label>IP Address</label>
          </div>
          <div class="col-sm-9">
            <b-input
              class="form-control-sm"
              v-model="formItem.ipAddress"
              trim
              required
              pattern="\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b"
              title="Invalid IP address"
            ></b-input>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <label>Comments</label>
          </div>
          <div class="col-sm-9">
            <b-input
              class="form-control-sm"
              v-model.trim="formItem.comments"
              trim
              required
              maxLength="200"
            ></b-input>
          </div>
        </div>
      </b-form>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="hideModal">Cancel</b-button>
        <b-button variant="primary" @click="addOrEditItem"
          >{{ isEdit ? 'Edit' : 'Add' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
/*global _*/
import http from '@/mixins/http';

export default {
  name: 'TrustedIPs',
  mixins: [http],
  mounted() {
    this.getList();
  },
  data() {
    return {
      path: 'trustedips',
      formItem: {
        trustedIPId: -1,
        ipAddress: '',
        comments: '',
      },
      formItemDefault: {
        trustedIPId: -1,
        ipAddress: null,
        comments: null,
      },
      isEdit: false,
      editId: -1,
      fields: [
        {
          key: 'ipAddress',
          label: 'IP Addresses',
          sortable: true,
        },
        {
          key: 'createdBy',
          label: 'Created By',
          sortable: true,
        },
        {
          key: 'createdAt',
          label: 'Created At',
          sortable: true,
        },
        {
          key: 'editedBy',
          label: 'Edited By',
          sortable: true,
        },
        {
          key: 'editedAt',
          label: 'Edited At',
          sortable: true,
        },
        {
          key: 'comments',
          label: 'Comments',
          sortable: true,
        },
        {
          key: 'trustedIPId',
          label: '',
          sortable: false,
        },
      ],
      items: [],
      perPage: 10000,
      currentPage: 1,
      isBusy: false,
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
    currentUser() {
      return this.$store.state.user;
    },
  },
  methods: {
    showModal() {
      this.isEdit = false;
      this.editId = -1;
      this.formItem = Object.assign({}, this.formItemDefault);
      this.formItem.options = [''];
      this.$refs['form-modal'].show();
    },
    showModalForEdit(data) {
      this.isEdit = true;
      this.editId = data.trustedIPId;
      this.formItem = _.cloneDeep(_.assign({}, this.formItemDefault, data));
      this.$refs['form-modal'].show();
    },
    hideModal() {
      this.$refs['form-modal'].hide();
    },
    getList() {
      var vm = this;
      this.axios.get('api/trustedips').then(function(resp) {
        if (resp.data) {
          vm.items = resp.data;
          vm.$refs['form-modal'].hide();
        }
      });
    },
    deleteItem(data) {
      var vm = this;
      var confirmMessage = 'Remove the IP address?';
      var id = data.trustedIPId;

      this.$bvModal
        .msgBoxConfirm(confirmMessage, { centered: true })
        .then(function(confirm) {
          if (confirm) {
            vm.axios.delete('api/trustedips/' + id).then(function(resp) {
              if (resp.data) {
                var index = _.findIndex(vm.items, { trustedIPId: id });
                vm.items.splice(index, 1);
                vm.$refs['form-modal'].hide();
                vm.$bvModal.msgBoxOk(
                  'IP address had been removed successfully',
                  {
                    okVariant: 'success',
                    centered: true,
                  }
                );
              }
            });
          } else {
            vm.$refs['form-modal'].show();
          }
        });
    },
    addOrEditItem() {
      var vm = this;
      var mainForm = vm.$refs['main-form'];

      if (!mainForm.reportValidity()) {
        return;
      }

      vm.$refs['form-modal'].hide();

      var confirmMessage = vm.isEdit
        ? 'Update the IP address?'
        : 'Add the IP address?';

      this.$bvModal
        .msgBoxConfirm(confirmMessage, { centered: true })
        .then(function(confirm) {
          if (confirm) {
            if (vm.isEdit) {
              vm.editItem();
            } else {
              vm.addItem();
            }
          } else {
            vm.$refs['form-modal'].show();
          }
        });
    },
    editItem() {
      var vm = this;
      vm.axios
        .put('api/trustedips/' + vm.editId, vm.formItem)
        .then(function(resp) {
          if (resp.data) {
            var index = _.findIndex(vm.items, { trustedIPId: vm.editId });
            vm.items.splice(index, 1, {
              ...vm.formItem,
              ...{ editedBy: vm.currentUser.name, editedAt: 'just now' },
            });
            vm.$refs['form-modal'].hide();
            vm.$bvModal.msgBoxOk('IP address had been updated successfully', {
              okVariant: 'success',
              centered: true,
            });
          }
        });
    },
    addItem() {
      var vm = this;
      vm.axios.post('api/trustedips', this.formItem).then(function(resp) {
        if (resp.data) {
          vm.getList();
          vm.$refs['form-modal'].hide();
          vm.$bvModal.msgBoxOk('IP address had been added successfully', {
            okVariant: 'success',
            centered: true,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-inline-text {
  cursor: pointer;
  font-weight: bolder;

  &:hover {
    color: #212529 !important;
    background-color: #007bff08;
  }
}
</style>